/**
 * Created by JasonChou on 17/6/19.
 */
import {getJsSdkConfigAPI} from '../apis/weixin'
import wx from '../libs/wxjssdk'

let isInit;

export default {
    async init(appId = null) {
        const jsApiList = ['chooseImage', 'uploadImage', 'getLocalImgData', 'previewImage',
            'hideMenuItems', 'showMenuItems',
            'hideAllNonBaseMenuItem',
            'onMenuShareTimeline', 'onMenuShareAppMessage'];

        // const res = await getJsSdkConfigAPI(window.location.origin + window.location.pathname);
        const res = await getJsSdkConfigAPI(window.location.href, appId);
        if (res.isOk) {

            let t = Date.now();

            const {app_id, noncestr, timestamp, signature} = res.data.data;
            wx.config({appId: app_id, nonceStr: noncestr, timestamp, signature, jsApiList,});
            return new Promise((resolve, reject) => {
                wx.ready(() => {
                    isInit = true;
                    resolve(wx)
                });
                wx.error((res) => {
                    reject()
                });
            })
        }
    },

    chooseImage(opts = {}) {
        if (window.__wxjs_is_wkwebview) {
            return new Promise((resolve, reject) => {
                wx.chooseImage({
                    ...opts,
                    success: (res) => {
                        const showPics = [];

                        const cb = () => {
                            if (showPics.length === res.localIds.length) {
                                resolve({upPics: res.localIds, showPics})
                            }
                        };

                        res.localIds.map((localId, i) => {
                            wx.getLocalImgData({
                                localId,
                                success: (res) => {
                                    showPics[i] = res.localData;
                                    cb();
                                }
                            });
                        });
                    }
                })
            })
        } else {
            return new Promise((resolve, reject) => {
                wx.chooseImage({
                    ...opts,
                    success: (res) => {
                        resolve({showPics: res.localIds, upPics: res.localIds})
                    }
                })
            })
        }
    },

    uploadImages(opts) {
        return new Promise(async (resolve, reject) => {
            const {localIds, ...o} = opts;
            const serverIds = [];

            for (let i = 0; i < localIds.length; i++) {
                const localId = localIds[i];
                let serverId = await this.uploadImage({localId, ...o})
                serverIds.push(serverId);
            }

            resolve(serverIds);
        })
    },

    uploadImage(opts) {
        return new Promise((resolve, reject) => {
            wx.uploadImage({
                ...opts,
                success: function ({serverId}) {
                    resolve(serverId);
                }
            });
        })
    },

    previewImage(opts) {
        wx.previewImage(opts);
    },

    hideMenuItems(opts) {
        wx.hideMenuItems(opts);
    },

    showMenuItems(opts) {
        wx.hideAllNonBaseMenuItem();
        wx.showMenuItems(opts);
    },

    onMenuShareTimeline(opts) {
        return new Promise((resolve, reject) => {
            wx.onMenuShareTimeline({
                ...opts,
                success: function ({serverId}) {
                    resolve(serverId);
                }
            });
        });
    },

    onMenuShareAppMessage(opts) {
        return new Promise((resolve, reject) => {
            wx.onMenuShareAppMessage({
                ...opts,
                success: function ({serverId}) {
                    resolve(serverId);
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/utils/wxUtils.js